// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4900":"e2378ff3","5004":"57d9e7aa","6529":"cf5e167a"}[chunkId] + ".chunk.css";
};